<template>
  <ModalDialog
    v-model="visible"
    :title="$localize('ConfirmRejectionModalTitle')"
    :is-danger="true"
    @open="onOpen"
  >
    <template #default>
      <TextAreaField
        id="rejectionReason"
        ref="rejectionReasonField"
        v-model="state.reason"
        :label="$localize('ConfirmRejectionReasonPrompt')"
        rows="3"
        :validation-rules="{
          required: { message: $localize('ReasonForRejectionRequired') },
          max: { message: $localize('ReasonForRejectionMaxLength'), length: 1000 }}"
      />
    </template>
    <template #footer>
      <VueButton
        :type="VueButtonTypes.default"
        @click="visible = false"
      >
        {{ $localize('Cancel') }}
      </VueButton>
      <VueButton
        :type="VueButtonTypes.danger"
        aria-describedby="rejectionReasonValidationMessage"
        @click="onContinue"
      >
        {{ $localize('Continue') }}
      </VueButton>
    </template>
  </ModalDialog>
</template>

<script lang="ts" setup>
  import ModalDialog from '@/VueComponents/Modals/ModalDialog.vue';
  import VueButton from '@/VueComponents/SharedComponents/Buttons/VueButton.vue';
  import { VueButtonTypes } from '@/VueComponents/SharedComponents/Buttons/Enums/VueButtonTypes';
  import TextAreaField from '@/VueComponents/SharedComponents/InputFields/TextAreaField.vue';
  import { nextTick, ref } from 'vue';
  import { useForm } from 'vee-validate';
  import useResetableState from '@/VueCore/utils/useResetableState';
  
  const emit = defineEmits(['continue']);
  const visible = defineModel<boolean>({ default: false });

  const { state, resetState } = useResetableState({
    reason: ''
  });

  const rejectionReasonField = ref();

  const form = useForm({
    initialValues: {
      rejectionReason: state.reason
    }
  });

  async function onContinue() {
    const result = await form.validate();

    if (result.valid) {
      emit('continue', state.reason);
    }
  }

  function onOpen() {
    resetState();
    nextTick(() => {
      rejectionReasonField.value.focus();
    });
  }
</script>

<style scoped>

</style>